// Abu Dhabi - AC repair.
const content = {
    slug: 'ac-repair',
    title: (c) => `AC Repair Abu Dhabi | ${c.money(c.tables.repairDiagnosis)} Diagnosis, Quote First`,
    description: (c) =>
        `AC repair in Abu Dhabi for villas and apartments. Diagnosis visit ${c.money(c.tables.repairDiagnosis)}; you get a quote and decide before any repair work.`,
    eyebrow: 'Abu Dhabi · AC repair',
    h1: 'AC Repair in Abu Dhabi',
    lead: (c) =>
        `A broken AC in an Abu Dhabi summer can't wait for the landlord to find a contractor. Book a diagnosis for ${c.money(c.tables.repairDiagnosis)} - the technician finds the fault, quotes the fix, and you decide.`,
    image: 'blog/living/aircon-printed-circuit-board.jpg',
    imageAlt: 'Technician testing an AC control board during a repair',
    facts: ['Fixed diagnosis fee', 'Written quote', 'Landlord-ready report'],
    priceTitle: 'Book a diagnosis visit',
    priceIntro: 'Choose the problem that fits best.',
    panel: {
        type: 'repair',
        problems: ['Not cooling', 'Not turning on', 'Water leaking', 'Error code', 'Noisy', 'Not sure'],
    },
    sections: [
        {
            title: 'What breaks most in Abu Dhabi summers',
            cards: [
                { title: 'Capacitors and contactors', body: 'Inland heat ages these parts fastest. Symptom: the outdoor unit hums or clicks but does not run.' },
                { title: 'Fan motors', body: 'Outdoor fan motors in sand-blown yards wear out; the compressor then overheats and cuts out.' },
                { title: 'Control boards', body: 'Power fluctuations and heat in roof spaces damage boards. Symptom: dead unit or an error code.' },
                { title: 'Drain problems', body: 'Humid island homes see more blocked drains and overflowing trays.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'Renting? Send the report to your landlord',
            tone: 'muted',
            paragraphs: [
                'Major AC repairs are usually the landlord\'s responsibility in Abu Dhabi rentals, but it depends on your tenancy contract. After the diagnosis you get the fault and the repair quote in writing, ready to forward to your landlord or agent for approval.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is AC repair in Abu Dhabi?',
            answer: (c) => `The diagnosis visit is ${c.money(c.tables.repairDiagnosis)}. Repair cost depends on the fault and part; you get the price before any work starts.`,
        },
        {
            question: 'Can you fix it on the first visit?',
            answer: 'Often - common parts like capacitors and contactors are carried on the van. Brand-specific boards and motors need a second visit once the part arrives.',
        },
        {
            question: 'Do you repair cassette and ducted units?',
            answer: 'Yes, as well as wall splits. Mention the unit type when you book.',
        },
    ],
    schema: {
        name: 'AC Repair in Abu Dhabi',
        serviceType: 'Air conditioner repair',
        offers: (c) => [{ name: 'AC repair diagnosis visit', price: c.tables.repairDiagnosis }],
    },
}

export default content
